// Google Maps
const customMarker = ({
    ...args
}) => {
    class CustomMarker extends google.maps.OverlayView {
        constructor() {
            super();
            this.drawed = false
            this.latLng = args.latLng
            this.html = args.html
            this.setMap(args.map)
        }

        draw() {
            const panes = this.getPanes();

            if (this.drawed === false) {
                this.div = document.createElement('div');
                this.div.className = "arrow_box";
                this.div.innerHTML = this.html;
                this.getPanes().overlayImage.appendChild(this.div);

                panes.overlayImage.appendChild(this.div);
                this.drawed = true
            }

            const position = this.getProjection().fromLatLngToDivPixel(this.latLng);
            panes.overlayImage.style.left = position.x + 'px';
            panes.overlayImage.style.top = position.y - 30 + 'px';
        }
    }
}


let map;



if ($('.contact-top-field').length) {
    let contactMapInfo = $('.contact-top-field .container .wrapper .contact-information-field .main-contact-field .contact-map-info > ul li')
    let contactInfo = $('.contact-top-field .container .wrapper .contact-information-field .main-contact-field .contact-info')
    let contactIMGField = $('.contact-top-field .container .wrapper .contact-information-field .image-field')
    let contactCursor = $('.contact-top-field .container .wrapper .map-field #map > div .cursor-field .cursor')
    let contactMapInfoID, contactInfoID, contactIMGFieldID, contactCursorID, mapLng, mapLat
    contactInfo.css({
        'height': $('.contact-top-field .container .wrapper .contact-information-field .main-contact-field .contact-info').find('ul.active').height()
    })
    setTimeout(() => {
        contactInfo.css({
            'height': $('.contact-top-field .container .wrapper .contact-information-field .main-contact-field .contact-info').find('ul.active').height()
        })
    }, 450);

    function mapChange() {
        mapLat = parseFloat($('.contact-top-field .container .wrapper .contact-information-field .general-content .contact-map-info ul li.active').attr('data-lat'))
        mapLng = parseFloat($('.contact-top-field .container .wrapper .contact-information-field .general-content .contact-map-info ul li.active').attr('data-lng'))
        contactMapInfo.click(function () {
            mapLat = parseFloat($(this).attr('data-lat'))
            mapLng = parseFloat($(this).attr('data-lng'))
            contactMapInfoID = $(this).attr('data-id')

            map.setCenter(new google.maps.LatLng(mapLat, mapLng));

            contactMapInfo.removeClass('active')
            $(this).addClass('active')

            $.each(contactInfo.find('ul'), function () {
                $(this).removeClass('active')
                contactInfoID = $(this).attr('data-id')
                if (contactMapInfoID == contactInfoID) {
                    $(this).addClass('active')
                    contactInfo.css({
                        'height': $(this).height()
                    })
                }
            })

            $.each(contactIMGField.find('.image-content-field'), function () {
                $(this).removeClass('active')
                contactIMGFieldID = $(this).attr('data-id')
                if (contactMapInfoID == contactIMGFieldID) {
                    $(this).addClass('active')
                }
            })

            $.each(contactCursor, function () {
                $(this).removeClass('active')
                contactCursorID = $(this).attr('data-id')
                if (contactMapInfoID == contactCursorID) {
                    $(this).addClass('active')
                }
            })
        })
    }
    mapChange()

    function initMap() {

        map = new google.maps.Map(document.getElementById("map"), {
            center: new google.maps.LatLng(mapLat, mapLng),
            zoom: mapZoom,
            mapTypeControl: false,
            disableDefaultUI: true,
            scrollwheel: true,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "saturation": "-100"
                        },
                        {
                            "lightness": "30"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "gamma": "0.00"
                        },
                        {
                            "lightness": "74"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "3"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                }
            ]
        });

        mapChange()
        
        for (i = 0; i < markerlocations.length; i++) {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(markerlocations[i][0], markerlocations[i][1]),
                map: map,
                icon: markerlocations[i][2], clickable: true,
                title: 'spot' + [i],
            });
        }
    }

    window.initMap = initMap;
}